import ResultsSection from "@/components/results-section";
import SeoMeta from "@/components/seo-meta";
import data from "@/data/setup.json";
import { buildMedicalBusinessJsonLd } from "@/lib/seo-data";

export default function ResultsPage() {
	return (
		<>
			<SeoMeta
				title={`Resultados | ${data.cliente.nome}`}
				description={data["area-resultados"]["texto-1"]}
				canonicalPath="/resultados"
				jsonLd={buildMedicalBusinessJsonLd(data)}
			/>
			<ResultsSection data={data} />
		</>
	);
}
